module.exports = __webpack_public_path__ + "img/logo12x.d20ae30d.png";